import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';
import {IListini, IProfile} from '../../interfaces/listini';

class EditProfiloModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$state',
    '$stateParams',
  ];

  private close: any;
  private dismiss: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $modalStack: ng.ui.bootstrap.IModalStackService,
    private $state: any,
    private $stateParams: ng.ui.IStateParamsService,
  ) {

    const listino = $scope.$parent.$resolve.listino as IListini;
    const profilo = $scope.$parent.$resolve.profilo as IProfile;
    $scope.profilo = JSON.parse(JSON.stringify(profilo));
    const pIndex = listino.profileList.findIndex(p => p.code === profilo.code && p.typeLimit === profilo.typeLimit && p.name === profilo.name && p.typeLimit === profilo.typeLimit);

    $scope.selectTypeLimit = {
      'FE': 'FE',
      'CE': 'CE',
      'PEC': 'PEC',
    };

    $scope.limit = $stateParams.limit;

    $scope.ok = () => {
      $scope.messaggio = null;
      listino.profileList[pIndex] = $scope.profilo;
      ArchiSmallServices.updateListino(listino).then(res => {
        this.close({$value: true});
      }).catch(err => {
        $scope.messaggio = `Errore durante la copia ${err.data.errorDescription}`;
        console.log(err);
      });

    };
    $scope.annulla = () => {
      this.close({$value: false});
    };
  }
}

export const EditProfiloModalComponent: ng.IComponentOptions = {
  template: require('./edit-profilo-modal.html'),
  controller: EditProfiloModalController,
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/edit-profilo-modal/edit-profilo-modal.ts